interface BrandLogoProps {
  /** light = weißer Rahmen für dunkle Hintergründe, dark = dantzBlue für helle Hintergründe */
  variant?: "light" | "dark"
  size?: "md" | "sm"
  className?: string
}

export default function BrandLogo({
  variant = "light",
  size = "md",
  className = ""
}: BrandLogoProps) {
  const frame =
    variant === "light"
      ? "border-white text-white"
      : "border-dantzBlue text-dantzBlue"
  const subtitleColor =
    variant === "light" ? "text-slate-300" : "text-secondary4"
  const padding = size === "md" ? "px-8 py-3" : "px-4 py-2"
  const titleSize = size === "md" ? "text-lg" : "text-sm"
  const subtitleSize = size === "md" ? "text-xs" : "text-[10px]"

  return (
    <div className={`border text-center ${frame} ${padding} ${className}`}>
      <div className={`${titleSize} whitespace-nowrap font-semibold tracking-wide`}>
        THE XPRESS IP COMPANY
      </div>
      <div className={`${subtitleSize} whitespace-nowrap tracking-widest ${subtitleColor}`}>
        INSTANT IP FILING
      </div>
    </div>
  )
}
